import {
  ProjectHeaderButton,
  RotateIcon,
} from "@/containers/Project/components/ProjectHeader/styled";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { Row } from "antd";

interface IProps {
  handleShowDetails: () => void;
  showDetails: boolean;
  expandButtonText: string;
  disableExpand: boolean;
}

export const ExpandButton = ({
  handleShowDetails,
  showDetails,
  expandButtonText,
  disableExpand,
}: IProps) => (
  <ProjectHeaderButton
    type="text"
    data-test-id="expand-button-project-info"
    onClick={handleShowDetails}
    disabled={disableExpand}
  >
    <Row justify="center">
      <RotateIcon
        size="2xl"
        icon={faCaretDown as IconProp}
        $expand={showDetails}
      />
    </Row>
    <Row justify="center">{expandButtonText}</Row>
  </ProjectHeaderButton>
);
